import {
    HOMEPAGE_SETTINGS_UPLOAD_START,
    HOMEPAGE_SETTINGS_UPLOAD_ERROR,
    HOMEPAGE_SETTINGS_UPLOAD_SUCCESS
} from '../../constants/index'
import { setLoaderStart, setLoaderComplete } from '../loader/loader';
import { updateHomePageSafetyMutation } from '../../lib/graphql';
import showToaster from '../../helpers/toastrMessgaes/showToaster';

const updateHomepageSettingsSafety = (values) => {

    return async (dispatch, getState, { client }) => {

        try {

            let title, description;
            title = values?.safetyGridTitle1.length && values?.safetyGridTitle1[0]?.value;
            description = values?.safetyGridTitle1.length && values?.safetyGridTitle1[0]?.description;

            dispatch({
                type: HOMEPAGE_SETTINGS_UPLOAD_START
            })

            dispatch(setLoaderStart('SafetySettingsForm'))
            const { data } = await client.mutate({
                mutation: updateHomePageSafetyMutation,
                variables: {
                    safetyGridImage1: values?.safetyGridImage1,
                    safetyGridImage2: values?.safetyGridImage2,
                    safetyGridImage3: values?.safetyGridImage3,
                    safetyGridTitle1: title,
                    safetyGridContent1: description,
                    safetyGridLink1: values?.safetyGridLink1,
                    safetyGridLink2: values?.safetyGridLink2,
                    safetyGridImage4: values?.safetyGridImage4,
                    dynamicAppSettings: values?.safetyGridTitle1
                }
            })

            dispatch(setLoaderComplete('SafetySettingsForm'))
            if (data?.updateHomePageSafety?.status == 200) {

                dispatch({
                    type: HOMEPAGE_SETTINGS_UPLOAD_SUCCESS
                })
                showToaster({ messageId: 'updateCitySuccess', toasterType: 'success' });
            } else {
                dispatch({
                    type: HOMEPAGE_SETTINGS_UPLOAD_ERROR
                })
                showToaster({ messageId: 'errorMessage', requestContent: data?.updateHomePageSafety?.errorMessage, toasterType: 'error' });
            }
        } catch (err) {
            dispatch({
                type: HOMEPAGE_SETTINGS_UPLOAD_ERROR
            })
            showToaster({ messageId: 'catchMessage', requestContent: err, toasterType: 'error' });
        }

    }
}

export default updateHomepageSettingsSafety;